export default {
  rev: {
    id: null,
    name: null,
    author: {},
    location: {
      organization: {},
      site: {},
      tags: [],
    },
    notes: null,
    status: null,
    onHoldReason: null,
    onHoldBy: null,
    onHoldAt: null,
    canceledReason: null,
    canceledBy: null,
    canceledAt: null,
    team: {
      owner: {},
      coach: {},
      collaborators: [],
    },
    categories: [],
    currencyMetadata: {
      exchangeRate: null,
      currentCurrency: null,
      globalCurrency: '',
    },
    reviewPhase: {
      costReduction: {
        capturedValue: null,
        calculatedValue: null,
      },
      investment: {
        capturedValue: null,
        calculatedValue: null,
      },
      revenue: {
        capturedValue: null,
        calculatedValue: null,
      },
      estimationExplanation: null,
      timeTracking: {
        timeReductionByMonth: null,
        timeInvested: null,
      },
    },
    createdAt: null,
    updatedAt: null,
    completedAt: null,
    completedBy: null,
    beforePhase: {
      situation: null,
      media: [],
      situationTypes: [
        {
          situation: null,
          type: null,
        },
      ],
    },
    afterPhase: {
      solution: null,
      media: [],
      suggestedTags: [],
    },
    currentPhase: null,
    organization: null,
    points: 0,
    likedByMe: false,
    approvedByMe: '',
    approvals: [],
    isApproved: false,

    totalLikes: 0,
    type: 'quickAction',
  },
  availableOwners: [],
  availableCollaborators: [],
  availableCoaches: [],
  challenges: [],
  impactStartsAt: null,
  impactEndsAt: null,
}
